import { render, staticRenderFns } from "./pict.vue?vue&type=template&id=44cfad3c&"
import script from "./pict.vue?vue&type=script&lang=js&"
export * from "./pict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports